import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  return (
    <header className="bg-[#4c7d4c] text-black  relative">
      <div className="container mx-auto px-6  ">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="text-2xl font-bold">
            <Link to="/" className="hover:opacity-90 transition-opacity">
              <img
                src="/images/icon/logo.png"
                className="img-fluid w-[100px] rounded-top"
                alt=""
              />

            </Link>
          </div>

          {/* Navigation */}
          <nav>
            <ul className="flex items-center space-x-8">
              {/* Our Services Dropdown */}
              <li
                className="relative group"
                onMouseEnter={() => setIsServicesOpen(true)}
                onMouseLeave={() => setIsServicesOpen(false)}
              >
                <button className="flex items-center space-x-1 hover:text-gray-200 transition-colors py-2">
                  <span>Our Services</span>
                  <svg
                    className={`w-4 h-4 transition-transform duration-200 ${isServicesOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </li>

              {/* Regular Links */}
              <li>
                <Link to="/investment" className="hover:text-gray-200 transition-colors py-2 block">
                  Our Investment
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-gray-200 transition-colors py-2 block">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-gray-200 transition-colors py-2 block">
                  Contact
                </Link>
              </li>

              {/* CTA Button */}
              <li>
                <Link
                  to="/get-started"
                  className="bg-pink-500 hover:bg-pink-600 text-white px-6 py-2 rounded-md font-semibold transition-colors"
                >
                  Get Started
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Mega Menu Dropdown */}
      <div
        className={`absolute left-0 right-0 z-50 bg-[#f5f5f5] border-t border-purple-700 shadow-2xl transition-all duration-300 ease-in-out overflow-hidden ${isServicesOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        onMouseEnter={() => setIsServicesOpen(true)}
        onMouseLeave={() => setIsServicesOpen(false)}
      >
        <div className="container max-w-7xl mx-auto px-6 py-8">
          <div className="grid grid-cols-4 gap-8">
            {/* Tax Services */}
            <div>
              <h3 className="font-bold text-lg mb-4  font-bold text-[#1A2B3C]">Business Registration</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/services/tax-planning" className="text-black hover:text-gray transition-colors">
                    Public Limited Company
                  </a>
                </li>
                <li>
                  <a href="/services/tax-preparation" className="text-black hover:text-gray transition-colors">
                    On Person Company
                  </a>
                </li>
                <li>
                  <a href="/services/tax-compliance" className="text-black hover:text-gray transition-colors">
                    Proprietorship
                  </a>
                </li>
                {/* <li>
                  <a href="/services/tax-advisory" className="text-black hover:text-gray transition-colors">
                    Tax Advisory
                  </a>
                </li> */}
              </ul>
            </div>

            {/* Business Services */}
            <div>
              <h3 className="font-bold text-lg mb-4  font-bold text-[#1A2B3C]">  GST</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/services/accounting" className="text-black hover:text-gray transition-colors">
                    GST
                  </a>
                </li>
                <li>
                  <a href="/services/bookkeeping" className="text-black hover:text-gray transition-colors">
                    Bookkeeping
                  </a>
                </li>
                <li>
                  <a href="/services/payroll" className="text-black hover:text-gray transition-colors">
                    Payroll Management
                  </a>
                </li>
                <li>
                  <a href="/services/cfo" className="text-black hover:text-gray transition-colors">
                    CFO Services
                  </a>
                </li>
              </ul>
            </div>

            {/* Advisory Services */}
            <div>
              <h3 className="font-bold text-lg mb-4  font-bold text-[#1A2B3C]">Advisory Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/services/financial-consulting" className="text-black hover:text-gray transition-colors">
                    Income Tax
                  </a>
                </li>
                <li>
                  <a href="/services/investment-advisory" className="text-black hover:text-gray transition-colors">
                    Investment Advisory
                  </a>
                </li>
                <li>
                  <a href="/services/risk-management" className="text-black hover:text-gray transition-colors">
                    Risk Management
                  </a>
                </li>
                <li>
                  <a href="/services/business-valuation" className="text-black hover:text-gray transition-colors">
                    Business Valuation
                  </a>
                </li>
              </ul>
            </div>

            {/* Specialized Services */}
            <div>
              <h3 className="font-bold text-lg mb-4  font-bold text-[#1A2B3C]">Specialized Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/services/estate-planning" className="text-black hover:text-gray transition-colors">
                    Estate Planning
                  </a>
                </li>
                <li>
                  <a href="/services/retirement-planning" className="text-black hover:text-gray transition-colors">
                    Retirement Planning
                  </a>
                </li>
                <li>
                  <a href="/services/international-tax" className="text-black hover:text-gray transition-colors">
                    International Tax
                  </a>
                </li>
                <li>
                  <a href="/services/audit-support" className="text-black hover:text-gray transition-colors">
                    Audit Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
